export default {
  suggestedContacts: []
}
